module.exports = __webpack_public_path__ + "static/media/story-19.0214ca9f.jpg";